import { offset, shift, useFloating } from '@floating-ui/react-dom';
import { Popover } from '@headlessui/react';
import { BellIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { NotificationList, NotificationListProps } from './NotificationList';

type NotificationTooltipProps = NotificationListProps & {
  disabled?: boolean;
};

export function NotificationTooltip({
  notifications,
  onNotificationRead,
  disabled,
}: NotificationTooltipProps) {
  const { refs, floatingStyles } = useFloating({
    placement: 'bottom',
    middleware: [offset(5), shift({ padding: 10 })],
  });

  return (
    <Popover className="relative">
      <Popover.Button
        ref={refs.setReference}
        disabled={disabled}
        title="Notifications"
        className="relative flex h-10 w-10 items-center justify-center rounded-lg text-white/80 transition hover:bg-white/10 hover:text-white disabled:cursor-not-allowed disabled:opacity-50"
      >
        <BellIcon className="h-5 w-5" />
        {notifications.length > 0 && (
          <span
            aria-label={`${notifications.length} unread`}
            className="absolute right-2 top-2 h-2.5 w-2.5 rounded-full border-2 border-dh-plum bg-white"
          />
        )}
      </Popover.Button>

      <Popover.Panel
        style={floatingStyles}
        className="z-30 overflow-hidden rounded-2xl text-dh-ink shadow-xl"
        ref={refs.setFloating}
      >
        <NotificationList
          notifications={notifications}
          onNotificationRead={onNotificationRead}
        />
      </Popover.Panel>
    </Popover>
  );
}
